import Colors from '@dynatrace/strato-design-tokens/colors';
import Typography from '@dynatrace/strato-design-tokens/typography';

import { SparklineXAxisInternalProps } from './types/sparkline-x-axis-props.js';
import type { SparklineYAxisProps } from './types/sparkline-y-axis-props.js';

export const defaultXAxisConfig: Required<SparklineXAxisInternalProps> = {
  min: 'data-min',
  max: 'data-max',
};

export const defaultYAxisConfig: Required<SparklineYAxisProps> = {
  min: 'data-min',
  max: 'data-max',
  scale: 'linear',
};

export const DEFAULT_SCALE_FALLBACK_COLOR = Colors.Text.Neutral.Default;

export const DEFAULT_SHOW_CONTEXT_VALUES = false;

export const TIMESTAMP_BAR_WIDTH = 5;
export const TIMESTAMP_BAR_X_DEVIATION = 2;

export const CONTEXT_VALUE_STROKE_DASHARRAY = '0.5,4';
export const CONTEXT_VALUE_STROKE_LINECAP = 'round';
export const CONTEXT_VALUE_STROKE_COLOR = Colors.Border.Neutral.Accent;

export const CONTEXT_VALUE_LINE_HEIGHT = 14;
export const CONTEXT_VALUES_INDICATOR_LEFT_OFFSET = 16;
export const CONTEXT_VALUES_INDICATOR_LABEL_SPACE = 4;

export const CONTEXT_VALUES_HEIGHT_OFFSET = 2;
export const CONTEXT_VALUES_Y_OFFSET = 0.5;
export const AXIS_HEIGHT = 25;

export const CONTEXT_VALUES_FONT = Typography.Text.Small.Emphasized;
export const CONTEXT_VALUE_MAX_WIDTH = 300;

export const SPARKLINE_ARIA_LABEL = 'Sparkline';
